import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeMinimum: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVolumeMinimum"><Path d="M13 21.0296V2.97046L5.8043 7.00005H1V17.0001H5.8043L13 21.0296Z" fill="currentColor"/><Path d="M16.1154 9.62442L15.7398 8.97522L14.4414 9.72633L14.817 10.3755C15.0931 10.8528 15.2513 11.4068 15.2513 12C15.2513 12.5933 15.0931 13.1473 14.817 13.6245L14.4414 14.2737L15.7398 15.0248L16.1154 14.3756C16.52 13.6762 16.7513 12.864 16.7513 12C16.7513 11.1361 16.52 10.3239 16.1154 9.62442Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVolumeMinimum;
